import { Navigate, useSearchParams } from 'react-router-dom';

/** Legacy route: assumptions live on planning cycles (same as stockerai-new). */
export function AssumptionsRedirect() {
  const [searchParams] = useSearchParams();
  const cycle = searchParams.get('cycle');
  const target = cycle
    ? `/demand-planning/sop/cycles?cycle=${cycle}`
    : '/demand-planning/sop/cycles';
  return <Navigate to={target} replace />;
}
